module.exports = __webpack_public_path__ + "static/media/wait_icn.db87ed58.png";